import { render, staticRenderFns } from "./UserCourseCancellation.vue?vue&type=template&id=93d5e780&"
import script from "./UserCourseCancellation.vue?vue&type=script&lang=js&"
export * from "./UserCourseCancellation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports